export default __webpack_public_path__ + "static/media/homebuyer-scrollover.b6ad17ee.jpg";